<div class="dialog-container-wrapper">
  <container-cms-view [container]="container"></container-cms-view>

  <i class="material-icons" (click)="close()">close</i>
</div>